<template>
  <div :class="['landingProductSummaryBox', getWrapperClass, boxSize, {disabled: data.soldOut}]">
    <a
      :href="getCampaignLink"
      class="adaptLink">
      <div class="img">
        <imageView
          :image="data.image"
          :desiredSize="productImageSize"
          :useBackEndSize="ifCampaignTypeList"
          :fitByHeight="ifCampaignTypeList"
          class="cover"/>
          <div v-if="data.soldOut" class="disabled">
            <span v-if="getWrapperClass === 'campaingTypeList'" class="staticText">Hemen keşfet</span>
          </div>
      </div>
      <div class="content">
        <div class="titleSection">
          <div class="title">{{ data.campaignName ? data.activeCampaignName || data.campaignName : (data.product && data.product.name) }}</div>
        </div>
        <div class="priceSection">
          <div class="priceWrapper">

            <div v-if="ifCampaignTypeList">
              <div class="price discount" v-if="data.product && data.product.finalPrice">
                <span class="number">
                  {{data.product.finalPrice}} TL
                </span>
              </div>
              <div v-if="(data.soldOut && data.missedDiscount)" class="price last">
                <span class="number">
                  {{ data.missedDiscount }} TL
                </span>
              </div>
              <div v-else-if="(!data.soldOut && data.isHero && data.product.finalPriceOnSale)" class="price last">
                <span class="number">
                  {{ data.product.finalPriceOnSale }} TL
                </span>
              </div>
              <div
                v-else-if="!data.soldOut"
                class="price last">
                Fırsatı Kaçırma
              </div>
            </div>
            <div v-else>
              <div
                class="price discount"
                v-if="data.product && data.product.finalPrice">
                <span class="number">{{data.product.finalPrice}}</span> TL
              </div>
              <div
                v-if="data.soldOut && data.missedDiscount"
                class="price last">
                <span class="number">{{data.missedDiscount}} TL</span>
              </div>
              <div
                v-else-if="data.product.finalPriceOnSale"
                class="price last">
                <span class="number">{{data.product.finalPriceOnSale}} TL</span>
              </div>
            </div>

          </div>
        </div>

        <div v-if="data.stockCount" class="stockInformation">
          Stoklar {{data.stockCount}} adetle sınırlıdır
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import imageView from "../../../components/imageView/imageView";

import {isMobileDeviceOrScreen} from "../../../common/agent/agentUtils";

import {PLATFORMS} from "../../../common/constants/constants";
import {BOX_SIZES, PRODUCT_IMAGE_SIZES} from "./landingProductSummaryBoxConstants";

export default {
  name: "landingProductSummaryBox",
  props: {
    data: Object,
    boxSize: {
      validator: function(value) {
        return (
          [BOX_SIZES.SMALL, BOX_SIZES.MEDIUM, BOX_SIZES.LARGE].indexOf(
            value
          ) !== -1
        );
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    ifCampaignTypeList: function () {
        return this.data.campaignType == 'liste';
    },
    getWrapperClass: function () {
      return this.ifCampaignTypeList
        ? 'campaingTypeList'
        : 'campaingTypeProduct';
    },
    getCampaignLink: function() {
      if(this.ifCampaignTypeList && this.data.isHero) {
        return this.data.linkDirection
      }

      return this.ifCampaignTypeList
        ? this.data.campaignLink
        : this.data.product.url;
    },
    productImageSize: function() {
      return isMobileDeviceOrScreen()
        ? PRODUCT_IMAGE_SIZES[PLATFORMS.MOBILE][this.boxSize]
        : PRODUCT_IMAGE_SIZES[PLATFORMS.DESKTOP][this.boxSize];
    },
  },
  components: {
    imageView
  }
};
</script>

<style src="./landingProductSummaryBox.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/view/productSummaryBoxes/landingProductSummaryBox/landingProductSummaryBox.vue